var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLinkedininline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 28.308,
    height: 28.308,
    className: "linkedin_inline_svg__css-12hibeq"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.154 28.308a14.06 14.06 0 01-10.008-4.146A14.062 14.062 0 010 14.153 14.061 14.061 0 014.146 4.145 14.061 14.061 0 0114.154-.001a14.062 14.062 0 0110.009 4.146 14.06 14.06 0 014.146 10.008 14.062 14.062 0 01-4.146 10.009 14.062 14.062 0 01-10.009 4.146zm2.122-14.336A1.6 1.6 0 0118 15.757v4.919h2.687v-5.051c0-2.482-1.26-3.965-3.371-3.965a2.906 2.906 0 00-2.654 1.485l.02-1.155H12c.037.8 0 8.358 0 8.679v.007h2.682v-4.919a1.934 1.934 0 01.1-.714 1.6 1.6 0 011.494-1.071zm-8.62-1.93v8.634h2.669v-8.634zm1.3-4.421a1.313 1.313 0 00-1.383 1.361 1.311 1.311 0 001.351 1.361h.016a1.313 1.313 0 001.383-1.361 1.309 1.309 0 00-1.361-1.36z",
    fill: "#fff"
  })));
}

export default SvgLinkedininline;